export default function doneTemplate() {
    return `
        <div class="done-elem">
            <svg viewBox="0 0 380 278" xmlns="http://www.w3.org/2000/svg">
                <path d="M334.418 7.68626L128.155 213.938L44.7775 130.578C34.5315 120.344 17.9335 120.338 7.6875 130.584C-2.5625 140.834 -2.5625 157.434 7.6875 167.68L109.613 269.59C114.735 274.706 121.445 277.266 128.155 277.266C134.865 277.266 141.594 274.706 146.714 269.582C146.73 269.56 146.741 269.538 146.767 269.512L371.506 44.7763C381.756 34.5363 381.756 17.9242 371.506 7.68424C361.262 -2.56176 344.652 -2.56174 334.418 7.68626Z"/>
            </svg>
        </div>
    `
}